import type { SVGProps } from 'react'

interface Props extends SVGProps<SVGSVGElement> {
  color?: string
  size?: string
}

const DiscountBadge = ({ color = '#3643BA', size = '16', ...props }: Props) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_703_9099)">
      <path
        d="M2.5668 5.74608C2.46949 5.30776 2.48443 4.85198 2.61023 4.42097C2.73604 3.98997 2.96863 3.59771 3.28644 3.28056C3.60425 2.96341 3.997 2.73164 4.42827 2.60674C4.85953 2.48184 5.31535 2.46786 5.75346 2.56608C5.9946 2.18895 6.3268 1.87859 6.71943 1.6636C7.11206 1.44862 7.55249 1.33594 8.00013 1.33594C8.44776 1.33594 8.8882 1.44862 9.28083 1.6636C9.67346 1.87859 10.0057 2.18895 10.2468 2.56608C10.6856 2.46743 11.1422 2.48135 11.5741 2.60656C12.0061 2.73176 12.3994 2.96417 12.7174 3.28218C13.0354 3.60019 13.2678 3.99346 13.393 4.42542C13.5182 4.85737 13.5321 5.31397 13.4335 5.75275C13.8106 5.99389 14.121 6.32608 14.3359 6.71871C14.5509 7.11135 14.6636 7.55178 14.6636 7.99941C14.6636 8.44705 14.5509 8.88748 14.3359 9.28011C14.121 9.67275 13.8106 10.0049 13.4335 10.2461C13.5317 10.6842 13.5177 11.14 13.3928 11.5713C13.2679 12.0025 13.0361 12.3953 12.719 12.7131C12.4018 13.0309 12.0096 13.2635 11.5786 13.3893C11.1476 13.5151 10.6918 13.5301 10.2535 13.4327C10.0126 13.8113 9.68018 14.123 9.28688 14.339C8.89358 14.5549 8.45215 14.6681 8.00346 14.6681C7.55478 14.6681 7.11335 14.5549 6.72004 14.339C6.32674 14.123 5.99429 13.8113 5.75346 13.4327C5.31535 13.531 4.85953 13.517 4.42827 13.3921C3.997 13.2672 3.60425 13.0354 3.28644 12.7183C2.96863 12.4011 2.73604 12.0089 2.61023 11.5779C2.48443 11.1469 2.46949 10.6911 2.5668 10.2527C2.18677 10.0122 1.87374 9.67953 1.65683 9.28556C1.43992 8.89158 1.32617 8.44915 1.32617 7.99941C1.32617 7.54968 1.43992 7.10724 1.65683 6.71327C1.87374 6.3193 2.18677 5.98659 2.5668 5.74608Z"
        stroke={color}
        strokeWidth={1.33333}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 6L6 10"
        stroke={color}
        strokeWidth={1.33333}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 6H6.00667"
        stroke={color}
        strokeWidth={1.33333}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 10H10.0067"
        stroke={color}
        strokeWidth={1.33333}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_703_9099">
        <rect width={16} height={16} fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default DiscountBadge
